export default {
  label: 'Login Settings',
  name: 'login',
  component: 'group',
  fields: [
    // LoginForm settings
    {
      label: 'Heading',
      name: 'heading',
      component: 'text',
      defaultValue: 'SIGN IN',
    },
    {
      label: 'Sub heading',
      name: 'subHeading',
      component: 'textarea',
      defaultValue: '',
    },
    {
      label: 'Button text',
      name: 'buttonText',
      component: 'text',
      defaultValue: 'Sign In',
    },
    {
      label: 'Forgot password text',
      name: 'resetText',
      component: 'text',
      defaultValue: 'Forgot your password?',
    },
    {
      label: 'Create account text',
      name: 'createText',
      component: 'text',
      defaultValue: "Don't have an account?",
    },
    {
      label: 'Create account link text',
      name: 'createLink',
      component: 'text',
      defaultValue: 'Sign up now',
    },
    {
      label: 'Need help? text',
      name: 'helpText',
      component: 'text',
      defaultValue: 'Need help?',
    },
    {
      label: 'Need help? link text',
      name: 'helpLink',
      component: 'link',
      defaultValue: {
        text: 'Contact Us.',
        url: '/pages/contact-us',
      },
    },

    // LoginRegisterLayout settings
    {
      label: 'Image',
      name: 'image',
      component: 'image',
      defaultValue:
        'https://images.unsplash.com/photo-1620492435196-5116e4a319ce?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=924&q=80',
      description: 'Image that will be seen on the right of the login form.',
    },
  ],
};
